import React from "react"
import type { UIMessage } from "@ai-sdk/react"
import { VerticalStackStretch } from "@mallardbay/lib-react-components"

import ChatMessagePart from "~components/shared/chat/chat-message-part"

interface Props {
    readonly message: UIMessage
}

export default function ChatMessageParts({ message }: Props) {
    return (
        <VerticalStackStretch>
            {message.parts.map((part, idx) => (
                <ChatMessagePart
                    key={getMessagePartKey({ message, idx })}
                    part={part}
                />
            ))}
        </VerticalStackStretch>
    )
}

function getMessagePartKey({
    message,
    idx,
}: {
    message: UIMessage
    idx: number
}) {
    return `${message.id}-${idx}`
}
